import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { buildPublicProposalUrl } from '@utils/public-proposal-url';

export const RedirectToPublicProposal = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    window.location.replace(buildPublicProposalUrl(`${pathname}${search}${hash}`));
  }, [pathname, search, hash]);

  return null;
};
